exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Comment-4a73634a{font-family:\"aktiv-grotesk\",\"Aktiv Grotesk\",\"Open Sans\",\"Gill Sans MT\",\"Gill Sans\",Corbel,Arial,sans-serif;font-size:15px;line-height:24px;color:#5C5C5C;white-space:pre-line}.Comment-4a73634a a{color:#00AAE6;text-decoration:none}.userIcon-49315f0e{height:40px;width:40px;object-fit:cover;border-radius:50%;float:left}.content-191d90ed{margin:0 0 40px 59px;padding-top:6px}.header-6997571c{font-size:14px;display:flex;flex-wrap:wrap}.header-6997571c a{white-space:nowrap}.dot-cb4bd5cc{margin:0 10px}a.delete-f220f4f8{color:#FF8E8E}.body-113da335{margin-top:4px;font-size:15px}.date-2bbc8b9d{color:#909090;white-space:nowrap}\n", ""]);

// Exports
exports.locals = {
	"Comment": "Comment-4a73634a",
	"userIcon": "userIcon-49315f0e",
	"content": "content-191d90ed",
	"header": "header-6997571c",
	"dot": "dot-cb4bd5cc",
	"delete": "delete-f220f4f8",
	"body": "body-113da335",
	"date": "date-2bbc8b9d"
};